import { Form } from "../Form";

export class PersonAddressesForm extends Form {
  protected definition = {};
}
